module.exports = __webpack_public_path__ + "static/media/01.5dda4a5f.jpg";